import { InjectionToken } from '@angular/core';

export interface OverlayPackageData {
  packageId: Guid;
  packageName: string;
}

export const OVERLAY_PACKAGE_DATA = new InjectionToken<OverlayPackageData>('OVERLAY_PACKAGE_DATA');